import React from 'react';

export default function UserCommunicationWelcomePage() {
    return <div>UserCommunicationWelcomePage</div>;
}
